"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSalesUser = isSalesUser;
exports.userCanCommunicate = userCanCommunicate;
exports.userCanViewQueues = userCanViewQueues;

var _SubjectPermissions = require("crm_ui/utils/SubjectPermissions");

var _ScopesContainer = _interopRequireDefault(require("crm_internal/containers/ScopesContainer"));

var _CurrentOwnerContainer = _interopRequireDefault(require("crm_internal/containers/CurrentOwnerContainer"));

function isSalesUser() {
  return _ScopesContainer.default.getContainer().get()['crm-access'];
}

function userCanCommunicate(_ref) {
  var subject = _ref.subject;
  return (0, _SubjectPermissions.canCommunicate)(subject);
}

function userCanViewQueues() {
  return !_CurrentOwnerContainer.default.isJitaUser;
}